import React from "react";
import usePriceSeprator from "../../../../hooks/usePriceSeparator";
import { Link } from "react-router-dom";

// styles
import styles from "../UserFilesDetail.module.css";
import DesktopSizeSlider from "./DesktopSizeSlider";
// import MobileSizeSlider from './MobileSizeSlider';

const UserFilesDetailFacilitiesSimilarFiles = ({ cardData, isMultiple, multipleID, dealType }) => {
  // let width = window.innerWidth;
  return (
    <>
      <div className="w-100 d-flex flex-column align-items-center justify-content-center">
        <div className="w-100 d-flex align-items-center justify-content-between flex-wrap">
          <div className={styles.text_title_md}>{isMultiple ? "آگهی های زیرمجموعه این آگهی" : "آگهی‌های مشابه"}</div>

          {isMultiple ? (
            <></>
          ) : (
            <Link to="/" className={`d-flex align-items-center justify-content-center mt-md-0 mt-3 ${styles.text_primary}`}>
              مشاهده همه
              <svg className="me-2" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.19416 0.712087C8.56028 1.0782 8.56028 1.6718 8.19416 2.03791L4.16958 6.0625H14.0938C14.6115 6.0625 15.0312 6.48223 15.0312 7C15.0312 7.51777 14.6115 7.9375 14.0938 7.9375H4.16958L8.19416 11.9621C8.56028 12.3282 8.56028 12.9218 8.19416 13.2879C7.82805 13.654 7.23445 13.654 6.86834 13.2879L1.24334 7.66291C0.877221 7.2968 0.877221 6.7032 1.24334 6.33709L6.86834 0.712087C7.23445 0.345971 7.82805 0.345971 8.19416 0.712087Z"
                  fill="#21409A"
                />
              </svg>
            </Link>
          )}
        </div>

        <DesktopSizeSlider cardData={cardData} usePriceSeprator={usePriceSeprator} isMultiple={isMultiple} multipleID={multipleID} dealType={dealType} />
        {/* {width > 768 ?
                    :
                    <MobileSizeSlider cardData={props.cardData} usePriceSeprator={usePriceSeprator} />
                } */}
      </div>
    </>
  );
};

export default UserFilesDetailFacilitiesSimilarFiles;
